<div class="chatblock">


<mat-card class="searchTab" *ngIf="showPanel">
    <div class="closeHeader">
        <button mat-icon-button (click)="closeChat(hide)">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="tabBar">
        <!-- <div class="bar">
            <button mat-icon-button matTooltipClass="tooltip" matTooltip="Contacts" >
                <mat-icon>perm_contact_calendar</mat-icon>
            </button>
            <span>Contact</span>
        </div>
        <div class="bar">
            <button mat-icon-button matTooltipClass="tooltip" matTooltip="Bookmark" >
                <mat-icon>bookmark</mat-icon>
            </button>
            <span>Bookmark</span>
        </div>
        <div class="bar">
            <button mat-icon-button matTooltipClass="tooltip" matTooltip="Favorites">
                <mat-icon>star_rate</mat-icon>
            </button>
            <span>Favorites</span>
        </div> -->
        <div class="bar">
            <button mat-icon-button (click)="searchBar()" matTooltipClass="tooltip" matTooltip="Search">
                <mat-icon>search</mat-icon>
            </button>
            <span>Search</span>
        </div>
        <div class="bar">
           
                <button mat-icon-button [matMenuTriggerFor]="menu" matTooltipClass="tooltip" matTooltip="New Chat/Group" >
                    <mat-icon>add</mat-icon>
                </button>
                <span>Group/Chat</span>
            
            <mat-menu #menu="matMenu" xPosition="before">
                <button mat-menu-item (click)="startNewChat(newChat)"><mat-icon>chat_bubble_outline</mat-icon> New Chat</button>
                  <button mat-menu-item (click)="startNewGroup(newGroup)"><mat-icon>group</mat-icon> New Group</button>
            </mat-menu>
        </div>

    </div>
    <div class="searchBar" *ngIf="showSearch">
        <div class="search">
            <input type="text" placeholder="Search contact or message" (input)="SearchChatOrMessages()" [(ngModel)]="searchTerm" >
              <button mat-icon-button (click)="SearchChatOrMessages()"><mat-icon>search</mat-icon></button>
            <!-- <input type="text" placeholder="Search message" >
            <button mat-icon-button ><mat-icon>search</mat-icon></button> -->
        </div>
        <button mat-icon-button (click)="searchBar()"><mat-icon>close</mat-icon></button>
    </div>
</mat-card>



    <mat-card class="header" *ngIf="!showPanel" >
        <button  (click)="closeChat(hide)"   mat-icon-button >
            <mat-icon class="secondary-text s-20">keyboard_arrow_right</mat-icon>
        </button>
    </mat-card>

    <!-- <div class="header selected dflex" *ngIf="showPanel"  fxLayout="row" fxLayoutAlign="space-between center"  >
        <div class="title  dflex" fxLayout="row" fxLayoutAlign="start center">
            <div class="selectedUser">
                    <img src="../../../../../assets/images/avatars/alice.jpg" alt="">
            </div>
                <h3 class="ml-12">Alice Freeman</h3>
        </div>

        <button  (click)="closeChat(hide)"   mat-icon-button class="toggle-sidebar-folded mr-8">
        <mat-icon class="secondary-text s-20">close</mat-icon>
        </button>
    </div> -->
    <div class="chatholder">
        <div class="chatlist">
            <span *ngIf="users.length == 0">
                <button mat-icon-button color="primary" [matMenuTriggerFor]="menu1" matTooltipClass="tooltip" matTooltip="New Chat/Group" >
                    <mat-icon>add</mat-icon>
                </button>

                <mat-menu #menu1="matMenu" xPosition="before">
                    <button mat-menu-item (click)="startNewChat(newChat)"><mat-icon>chat_bubble_outline</mat-icon> New Chat</button>
                      <button mat-menu-item (click)="startNewGroup(newGroup)"><mat-icon>group</mat-icon> New Group</button>
                </mat-menu>

            </span>
            <ul *ngIf="users.length != 0">
                <li [ngClass]="{ 'active': chatId === user.id }" *ngFor="let user of users" >
                    <div class="user" matTooltipPosition="before" matTooltipClass="tooltip" matTooltip="{{user.roomName}}">
                        <a (click)="chatDetails(user)" *ngIf="user.imageUrl">
                            <img src]="user.imageUrl">
                        </a>   
                        
                        <a (click)="chatDetails(user)">
                            {{getShortName(user.roomName)}} 
                        </a> 
                        <!-- <span class="status online" *ngIf="chatlist.status == 'online'"></span>
                        <span class="status offline" *ngIf="chatlist.status == 'offline'"></span>
                        <span class="status away" *ngIf="chatlist.status == 'away'"></span>
                        <span class="status do-not-disturb" *ngIf="chatlist.status == 'do-not-disturb'"></span> -->                       
                    
                    </div>
                </li>
            </ul>
        </div>
        <div class="chatsheet">
            <mat-card class="chatHeader">
                <div class="userPic" *ngIf="imageUrl">
           <img [src]="imageUrl" alt="" />     
        </div>
        <div class="userPic" *ngIf="!imageUrl">
         <span>{{getShortName(groupname)}}</span>
        </div>
        <div class="info">        
        <h3>{{groupname}}</h3>
        </div>
                <!-- <div class="userPic">
                    <img src="../../../../assets/images/avatars/Abbott.jpg" alt="">
                </div>
                <div class="info">
                    <h3>Matt MacAlpin123</h3>
                </div> -->
            
                <div class="call">
                    <!-- <button mat-icon-button><mat-icon>call</mat-icon></button>
                    <button mat-icon-button><mat-icon>videocam</mat-icon></button> -->
                    <!-- <button mat-icon-button (click)="addFolder(addFolderDialog)" ><mat-icon>group_add</mat-icon></button> -->
                </div>
            
            </mat-card>
            
            <mat-card class="chatConatiner">
             <div class="" #scrollMe  [scrollTop]="scrollMe.scrollHeight"  style="overflow: auto;">
            
                <ng-container  *ngFor="let msg of messageList">    
                    
                <div class="timeStamp">
                    <span>{{msg.dates| date:'EEE, MMM d, y'}}</span>
                    <!-- <span>wed, sep 25, 2019</span> -->
                </div> 
            
                <ng-container  *ngFor="let user of msg.values">
            
                    <!-- <div class="chatBlock" *ngIf="user.fromUser?.email !=currentUser.UID"> -->
                    <div class="chatBlock" *ngIf="user.fromUser?.email != loggedinEmail">
  
                        <div class="userPic" *ngIf="user.fromUser?.profileImageUrl">
                            <img [src]="user.fromUser.profileImageUrl" alt="" />  
                        </div>
                        <div class="userPic" *ngIf="!user.fromUser?.profileImageUrl">
                            <span>{{getShortName(user.fromUser?.userName)}}</span>
                          </div>
                        <div class="chatMessageWStamp">
                            <div class="nameDateIcons">   
                                <!-- <span>{{user.createdOn | date:'MM/dd/yyyy h:mm a'}}</span> -->
                               {{user.fromUser?.userName}}, <span>{{user.createdOn | date:'h:mm a'}}</span>
                            </div>
                            <div class="chatMessage withFileMessage" *ngIf="user.filePath!=''" >
                              <p (click)="openDocumentViewer(true,user,docViewer)"> 
                              <mat-icon class="ftype"> description</mat-icon> {{user.fileName}}
                             </p>
                            </div>
                            <div class="chatMessage" *ngIf="user.message">
                                <p>{{user.message}}</p>                
                                <!-- <div class="actionIcons">
                                    <button mat-icon-button color=""> <mat-icon>thumb_up</mat-icon> </button>
                                    <button mat-icon-button color=""> <mat-icon>bookmark_add</mat-icon> </button>
                                </div> -->
                            </div>
                
                            
                
                        </div>
                    </div>
                
                   
                    <div class="chatBlock selfMessage"  *ngIf="user.fromUser?.email == loggedinEmail">
                        <div class="userPic" *ngIf="user.fromUser?.profileImageUrl">
                            <img [src]="user.fromUser?.profileImageUrl" alt="" />  
                        </div>
                        <div class="userPic" *ngIf="!user.fromUser?.profileImageUrl">
                            <span>{{getShortName(user?.fromUser.userName)}}</span>
                          </div>
                        <div class="chatMessageWStamp" *ngIf="user.fromUser?.email == loggedinEmail">
                            <div class="nameDateIcons">               
                                <span>{{user.createdOn | date:'h:mm a'}}</span>
                            </div>
                            <div class="chatMessage withFileMessage" *ngIf="user.filePath!=''">
                                <p (click)="openDocumentViewer(true,user,docViewer)">
                                    <mat-icon class="ftype"> description</mat-icon> {{user.fileName}}
                                </p>
                            </div>
                            <div class="chatMessage" *ngIf="user.message">
                                <p>{{user.message}}</p>                
                            </div>                                  
                
                        </div>
                    </div>
                </ng-container>

               </ng-container>
            
            </div>
            </mat-card>
            
            <mat-card class="postMessage">
                <div class="post">
                    <div class="fileAttach" *ngIf="filepath!=''">
                        <!-- File to send path: {{filepath}} -->
                        <mat-icon class="ftype"> description</mat-icon> {{fileName}} <button mat-icon-button class="close" color="basic" (click)="cancelUploadFile()" ><mat-icon>highlight_off</mat-icon> </button>
                    </div>
                    <textarea placeholder="Type your message" [(ngModel)]="message"
                    (input)="onChangeMessage($event.target.value)" (keydown.enter)="onEnter($event)"></textarea>   
                </div>
                <!-- <emoji-mart class="emoji-mart" set="{{set}}" *ngIf="showEmojiPicker" (emojiSelect)="addEmoji($event)" title="Pick your emoji…"></emoji-mart> -->
                <!-- <button mat-icon-button><mat-icon>insert_emoticon</mat-icon></button> -->
                <input #Input hidden="true" type="file"  (change)="handleFileInput($event.target.files)">
                <button mat-icon-button (click)="Input.click()"><mat-icon>attach_file</mat-icon></button>
                <button mat-icon-button color="primary" 
                [disabled]="!sendButtonShow" (click)="send()"><mat-icon>send</mat-icon></button>
            </mat-card>
        </div>
    </div>
</div>





<ng-template #newChat>
    <h2 mat-dialog-title>
       <span class="groupIcon"><mat-icon>chat_bubble_outline</mat-icon></span>
        New Chat        
          <button mat-icon-button (click)="close()"> <mat-icon>close</mat-icon> </button>
        </h2>
    
  <mat-dialog-content class="mat-typography">

    <div class="searchUser">
        <mat-form-field appearance="fill">
            <mat-label>Search Email</mat-label>
            <input matInput type="text" maxlength="20"
            (input)="SetSearchValue($event.target.value)"> 
          </mat-form-field>
          <button [disabled]="!isEnabled" mat-fab color="primary" (click)="SearchEmail()"><mat-icon>search</mat-icon>
            <mat-icon *ngIf="spinner">
            <mat-spinner diameter="20">
        </mat-spinner>
    </mat-icon></button>
    </div>
  

    <ul class="selectedlist">
      
      <li *ngFor="let user of peoples">
        <div class="userndetail" (click)='CreateNewChat(user)'>
            <div class="pic" *ngIf="user.profileImagePath">
              <img [src]="user.profileImagePath" alt="" />  
            </div>
            <div class="pic" *ngIf="!user.profileImagePath">
              <span>{{getShortNameEmail(user.email)}}</span>
            </div>
            <div class="detail">
                <h4>{{user.email}}</h4>
                <!-- <p>{{user.email}}</p> -->
            </div>
        </div>       
      </li>
     
    </ul>
  
    
  </mat-dialog-content>
  
</ng-template>


<ng-template #newGroup>
    <h2 mat-dialog-title>
       <span class="groupIcon"><mat-icon>chat_bubble_outline</mat-icon></span>
        New Group Chat        
          <button mat-icon-button (click)="close()"> <mat-icon>close</mat-icon> </button>
        </h2>
    
  <mat-dialog-content class="mat-typography">

    <mat-form-field appearance="outline">
        <mat-label>Group Name</mat-label>
        <input matInput placeholder="Add Group Name" maxlength="50" 
        [(ngModel)]="groupName" (input)="onChange($event.target.value)"  required>
      </mat-form-field>

      <div class="searchUser">
        <mat-form-field appearance="fill">
            <mat-label>Search User</mat-label>
            <input matInput type="text" maxlength="20"
            (input)="SetSearchValue($event.target.value)">        
          </mat-form-field>
        <button [disabled]="!isEnabled" mat-fab color="primary" (click)="Search()"><mat-icon>search</mat-icon></button> 
      </div>
  

  
    <ul class="selectedlist">      
      <li *ngFor="let user of peoples">
        <div class="userndetail" (click)='SelectUser($event,user)'>
            <div class="pic" *ngIf="user.profileImagePath">
              <img [src]="user.profileImagePath" alt="" />  
            </div>
            <div class="pic" *ngIf="!user.profileImagePath">
              <span>{{getShortNameEmail(user.email)}}</span>
            </div>
            <div class="detail">
                <h4>{{user.name}}</h4>
                <!-- <p>{{user.email}}</p> -->
            </div>
        </div>
        <div class="option">
            <mat-checkbox color="primary" [checked]="user.isChecked"
             (change)='SelectUser($event,user)'></mat-checkbox>
        </div>
      </li>
     
    </ul>
  
    
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="!DoneButtonShow"
    (click)="CreateNewGroup()">Done</button>
  </mat-dialog-actions>
</ng-template>


<ng-template #docViewer>
    <app-document-viewer 
    (getCloseDocumentViewer)="getCloseDocumentViewer($event)"
    [ngClass]="{ open: documentViewer }"></app-document-viewer>
</ng-template>


<ng-template #addFolderDialog>
    <h2 mat-dialog-title>
       <span class="groupIcon" ><mat-icon>group_add</mat-icon></span>
        Select contact to add in group
        
          <button mat-icon-button (click)="close()">
            <mat-icon>close</mat-icon>
          </button>
        </h2>
    
  <mat-dialog-content class="mat-typography">
  
    <!-- <mat-form-field  appearance="fill">
      <input matInput
             placeholder="Search Contact"
             aria-label="State"            
             [formControl]="stateCtrl">
    </mat-form-field> -->
  
  
    <ul class="selectedlist" >
      
      <li *ngFor="let user of peoples" >
        <div class="userndetail">
            <div class="pic">
              <img src="../../../assets/images/avatars/{{user.img}}" alt="" >
            </div>
            <div class="detail">
                <h4>{{user.name}}</h4>
                <!-- <p>{{user.email}}</p> -->
            </div>
            
        </div>
        <div class="checkOpt">

            <mat-checkbox color="primary"></mat-checkbox>

        </div>
      </li>
     
    </ul>
  
    
  </mat-dialog-content>
  <mat-dialog-actions >
    <button class="radius" mat-button (click)="close()">Cancel</button>
    <button class="radius" mat-flat-button color="primary" >Create</button>
  </mat-dialog-actions>
</ng-template>

<div class="progress-loader" *ngIf="spinner">
    <div class="lds-ripple" ><div></div><div></div></div>
  </div>